var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticStyle:{"width":"100vw","-webkit-touch-callout":"none"},attrs:{"src":_vm.article.url,"alt":""}})}
var staticRenderFns = []

export { render, staticRenderFns }